import { render, staticRenderFns } from "./mappingPositioning.vue?vue&type=template&id=5ac27f3c&"
import script from "./mappingPositioning.vue?vue&type=script&lang=js&"
export * from "./mappingPositioning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports